export default __webpack_public_path__ + "static/media/wojak-green.df4f56f0.png";